export interface PricingLine {
  label: string;
  value: string;
  emphasis?: boolean;
}

/**
 * Our deal with operators, straight up. The only number that isn't zero
 * is our cut — 10% of GGR (gross gaming revenue the game earns for the
 * operator, i.e. total bets minus total wins).
 *
 * Settlement is in stablecoins (USDT or USDC, on Solana, Ethereum, or
 * Polygon). No fiat rails — that means no setup delays, no IBANs, no
 * bank-side compliance review. The on-chain settlement schedule is
 * weekly Mondays UTC. Reconciliation happens against the operator's
 * round logs from the RGS.
 */
export const PRICING_LINES: PricingLine[] = [
  { label: "Setup fee", value: "$0" },
  { label: "Monthly minimum", value: "$0" },
  { label: "Integration fee", value: "$0" },
  { label: "License fee", value: "$0" },
  { label: "Our revenue share", value: "10% of GGR", emphasis: true },
  { label: "Settlement", value: "USDT/USDC · weekly" },
];

export const PRICING_SUMMARY =
  "We give you the game for free. We take 10% of the gross gaming revenue the game earns, settled weekly in stablecoins (USDT/USDC on Solana, Ethereum, or Polygon). If the game doesn't earn, we don't earn. That's the whole deal.";
